import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPpp } from './pages'

type TIdToPageMapWoofzPpp = Record<PageIdWoofzPpp, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PPP: TIdToPageMapWoofzPpp = {
  [PageIdWoofzPpp.DOG_AGE_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/DogAgePpp').then((m) => ({
        default: m.DogAgePpp,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp/pages/questions/DogAgePpp'),
  },
  [PageIdWoofzPpp.DOG_OWNER_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/DogOwnerQuestion').then(
        (m) => ({
          default: m.DogOwnerQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/DogOwnerQuestion'),
  },
  [PageIdWoofzPpp.TRAINING_COMMANDS_WOOFZ_PPP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp/pages/questions/BasicTrainingCommands'
      ).then((m) => ({
        default: m.BasicTrainingCommands,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/BasicTrainingCommands'),
  },
  [PageIdWoofzPpp.URGE_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp/pages/urge/UrgePage'),
  },
  [PageIdWoofzPpp.DOG_BREED_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/DogBreedQuestion').then(
        (m) => ({
          default: m.DogBreedQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzPpp.FACING_CHALLENGES_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/FacingChallenges').then(
        (m) => ({
          default: m.FacingChallenges,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/FacingChallenges'),
  },
  [PageIdWoofzPpp.FACING_CHALLENGES_2_WOOFZ_PPP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp/pages/questions/FacingChallengesVersion2'
      ).then((m) => ({
        default: m.FacingChallengesVersion2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp/pages/questions/FacingChallengesVersion2'
      ),
  },
  [PageIdWoofzPpp.BEHAVIOR_FREQUENCY_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/BehaviorFrequency').then(
        (m) => ({
          default: m.BehaviorFrequency,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/BehaviorFrequency'),
  },
  [PageIdWoofzPpp.URGE_PROGRAM_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/urge/UrgeProgram').then((m) => ({
        default: m.UrgeProgram,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzPpp.BEHAVIOR_FEELINGS_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/BehaviorFeelings').then(
        (m) => ({
          default: m.BehaviorFeelings,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/BehaviorFeelings'),
  },
  [PageIdWoofzPpp.FIX_BEHAVIOR_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/FixDogBehavior').then(
        (m) => ({
          default: m.FixDogBehavior,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/FixDogBehavior'),
  },
  [PageIdWoofzPpp.URGE_4_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzPpp.COMMANDS_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/DogCommands'),
  },
  [PageIdWoofzPpp.PARENT_GOAL_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/GoalQuestion').then(
        (m) => ({
          default: m.GoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/GoalQuestion'),
  },
  [PageIdWoofzPpp.TRAINING_PLACE_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/TrainingPlace').then(
        (m) => ({
          default: m.TrainingPlace,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/TrainingPlace'),
  },
  [PageIdWoofzPpp.TRAINING_FREQUENCY_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/questions/TimeQuestion'),
  },
  [PageIdWoofzPpp.URGE_5_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzPpp.PREPARE_FLOW_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/prepare-flow/PrepareFlowPpp').then(
        (m) => ({
          default: m.PrepareFlowPpp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/prepare-flow/PrepareFlowPpp'),
  },
  [PageIdWoofzPpp.EMAIL_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/email/EmailPpp').then((m) => ({
        default: m.EmailPpp,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp/pages/email/EmailPpp'),
  },
  [PageIdWoofzPpp.NEWSLETTER_URGE_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPpp.LAST_CHANCE_OFFER_WOOFZ_PPP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp/pages/last-chance-offer/LastChanceOfferPpp'
      ).then((m) => ({
        default: m.LastChanceOfferPpp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp/pages/last-chance-offer/LastChanceOfferPpp'
      ),
  },
  [PageIdWoofzPpp.WELCOME_TO_WOOFZ_WOOFZ_PPP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp/pages/last-chance-offer/ab-test/WelcomeToWoofz'
      ).then((m) => ({
        default: m.WelcomeToWoofz,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppp/pages/last-chance-offer/ab-test/WelcomeToWoofz'
      ),
  },
  [PageIdWoofzPpp.SUBSCRIPTIONS_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/subscriptions/Subscriptions').then(
        (m) => ({
          default: m.Subscriptions,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzPpp.CHAT_UPSELL_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzPpp.UPSELL_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ppp/pages/upsell/Upsell'),
  },
  [PageIdWoofzPpp.UPSELL_FEEDING_GUIDE_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzPpp.UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppp/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzPpp.DOWNLOAD_WOOFZ_PPP]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ppp/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppp/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPpp.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
